import moment from 'moment'
function getOpeningHoursForDate (dayMoment, openingHours) {
  // filtrar qué working hours incluyen ese día
  const dayOpeningHours = openingHours.filter((wH) => {
    if (!wH.startDate && !wH.endDate) return true
    return moment(wH.startDate).startOf('day').isSameOrBefore(dayMoment) && moment(wH.endDate).endOf('day').isSameOrAfter(dayMoment)
  })
  // de esos, obtener los más cortos
  let chosenWorkingHour = null
  let currentLength = null
  dayOpeningHours.forEach(workingHour => {
    if (!currentLength) {
      currentLength = moment(workingHour.endDate).endOf('day').diff(moment(workingHour.startDate))
      chosenWorkingHour = workingHour
    } else {
      if (moment(workingHour.endDate).endOf('day').diff(moment(workingHour.startDate)) === currentLength) {
        // si hay más de uno, quedarse con el que haya empezado después
        if (moment(chosenWorkingHour.startDate).isBefore(workingHour.startDate)) {
          chosenWorkingHour = workingHour
        }
      } else if (moment(workingHour.endDate).endOf('day').diff(moment(workingHour.startDate)) < currentLength) {
        currentLength = moment(workingHour.endDate).endOf('day').diff(moment(workingHour.startDate))
        chosenWorkingHour = workingHour
      }
    }
  })
  return chosenWorkingHour
}
export {
  getOpeningHoursForDate,
}
